import { previewModeRegex } from '../constants'

function getPreviewMode(url) {
  return url.match(previewModeRegex)?.[1]
}

export default getPreviewMode
